import { Stack, Typography } from '@optimus-web/core';
import { lt, FormInputField } from '@mews/framework';
import { FieldNames } from '../formEnums';

export const InternalFields = () => (
    <>
        <Stack vertical spacing="100">
            <Typography textStyle="bodyLargeStrong" as="div">
                {lt('InternalDetails')}
            </Typography>
            <Typography textStyle="bodyMedium" variant="secondary" as="div">
                {lt('InternalDetailsDescription')}
            </Typography>
        </Stack>

        <FormInputField label={lt('InternalName')} name={FieldNames.Name} required />
        <FormInputField label={lt('ShortName')} name={FieldNames.ShortName} />
    </>
);
